export enum ProductGroupTypes {
    Trademark = 't',
    CustomerRelations = 'c',
    Goodwill = 'g',
    Technology = 'e',
    Software = 's',
    None = 'a',
}
